import { emitVarunaLoginSynced } from '@/plugins/emitter'
import {
  clearReferralCode,
  loadReferralCode
} from '@/utils/yagiprime/referralVisitor'

/** OCR利用統計用セッションIDを formDataに付与する */
function appendOcrSessionId(formData: FormData): void {
  const ocrSessionId = localStorage.getItem('ocr_session_id')
  if (ocrSessionId) formData.append('ocr_session_id', ocrSessionId)
}

/** OEM情報をformDataに付与する */
function appendOemInfo(formData: FormData, vueInstance: any): void {
  const oemContext = vueInstance.$oemContext
  const isOemEnvironment = oemContext && oemContext.currentOemId

  formData.append('oem_flg', isOemEnvironment ? 'true' : 'false')

  if (isOemEnvironment && oemContext.currentOemUniqueId) {
    formData.append('oem_id', oemContext.currentOemUniqueId)
  } else {
    const cookieOemId = vueInstance.$cookies
      ? vueInstance.$cookies.get('_YAGISH_OEM_UNIQUE_ID')
      : null
    if (cookieOemId) {
      formData.append('oem_id', cookieOemId)
    }
  }
}

export type LoginFormUser = {
  uid: string
  email?: string | null
  emailVerified?: boolean
}

type BuildLoginFormOptions = {
  /** 空文字で送る（redirect で email 無しのとき） */
  email?: string
  includeConfirmCode?: boolean
  includeUnivId?: boolean
}

/** Varuna login 向け FormData を組み立てる（経路間で共通） */
/**
 * ヤギプライム紹介キャンペーンの紹介コードを付与する。
 *
 * 紹介URL(/r/<code>)の着地で localStorage に保存した値。サーバーは
 * ヤギプラ未加入の会員（新規登録・既存会員とも）を被紹介者として受け付けるため、
 * 登録・ログインのリクエストに載らないと紹介が成立しない。
 * 未保存・期限切れ（30日）は空文字が返るのでキーごと付けない。
 */
function appendReferralCode(formData: FormData): void {
  const referralCode = loadReferralCode()
  if (referralCode) formData.append('referral_code', referralCode)
}

export function buildVarunaLoginFormData(
  vueInstance: any,
  user: LoginFormUser,
  options: BuildLoginFormOptions = {}
): FormData {
  const formData = new FormData()
  formData.append('uuid', user.uid)
  const email = options.email !== undefined ? options.email : user.email || ''
  formData.append('email', email)

  if (options.includeConfirmCode) {
    const confirmCode = vueInstance.$cookies.get('_TEMPDATA_CONFIRM_CODE')
    formData.append('confirm_code', confirmCode)
  }

  const athleteUnivId = vueInstance.$cookies.get('_YAGISH_ATHLETE_UNIVID')
  if (athleteUnivId) formData.append('athlete_univ_id', athleteUnivId)
  const affiliateId = vueInstance.$cookies.get('_YAGISH_AFFILIATE_ID')
  if (affiliateId) formData.append('affiliate_id', affiliateId)
  appendReferralCode(formData)

  formData.append('app_flag', vueInstance.$site.appFlag)
  formData.append('site_flag', 'r')
  if (options.includeUnivId) {
    formData.append('univ_id', '')
  }
  formData.append('email_verified', user.emailVerified ? '1' : '0')
  formData.append(
    'device_flag',
    vueInstance.$deviceLib.isMobileDevice ? 'SP' : 'PC'
  )
  appendOcrSessionId(formData)
  appendOemInfo(formData, vueInstance)
  return formData
}

/** Varuna login を POST する（購読側ゼロの login_redirect_function 発火は削除済み） */
export function postVarunaLogin(vueInstance: any, formData: FormData): void {
  vueInstance.$axios
    .post(vueInstance.$varuna.endPoints.login, formData)
    .then(function () {
      // 紹介コードは送ったら使い切る。30日残したままだと、同じブラウザで
      // あとから別アカウントを登録したときにその人まで同じ紹介者に紐付く
      // （サーバー側は「登録から60分以内の新規会員」しか見ないので、
      //   新しいアカウントほど条件を満たしてしまう）
      clearReferralCode()
      // 紹介の紐付けはこの POST でサーバー側に確定する。Firebase の認証成功
      // だけを見ると間に合わないので、待っている画面へ知らせる
      emitVarunaLoginSynced()
    })
    .catch(function (error: unknown) {
      console.error(error)
    })
}
